import i18nIsoCountries from "i18n-iso-countries"
import countriesList from "i18n-iso-countries/langs/en.json"

i18nIsoCountries.registerLocale(countriesList)
export const countries: {[countryCode: string]: string} = i18nIsoCountries.getNames("en")
